import './custom-jquery';
import './cookies-consent';
import './navigation';


(function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde);

    /**
     * Retourne un objet contenant les champs utm_source,utm_content,utm_medium, utm_campaign, utm_term
     */
     w.Kinougarde.GetGlobalUtmFields =function() {
        var data = {}
        try {
        var analyticsDatas = w.Kinougarde.GetStorage('Kinougarde-analytics');
        if (window.sessionStorage.getItem("__utm_source")!=null) {
            // __utm_source posé par GTM pour tracker les pages SEO
            return {
                UtmSource : window.sessionStorage.getItem("__utm_source"),
                UtmContent : window.sessionStorage.getItem("__utm_content"),
                UtmMedium : window.sessionStorage.getItem("__utm_medium"),
                UtmTerm : window.sessionStorage.getItem("__utm_term"),
                UtmCampaign : window.sessionStorage.getItem("__utm_campaign")                
              };
        }
        if (analyticsDatas) {             
             data = {
               UtmSource : analyticsDatas.utm_source,
               UtmContent : analyticsDatas.utm_content,
               UtmMedium : analyticsDatas.utm_medium,
               UtmTerm : analyticsDatas.utm_term,
               UtmCampaign : analyticsDatas.utm_campaign,
               clickid : analyticsDatas.clickid, 
               clicksource : analyticsDatas.clicksource              
             };
        }        
       } catch(e) {
         console.warn("Erreur in methode GetGlobalFields");
       }
       return data;
    };
 
    /**
     * Function qui capte les paramètres d'url global
     *  - agence par défaut 
     *  - utm
     *  - gclid
     */
    w.Kinougarde.GetGlobalQueryParameter = function() {
    var queryParams = this.GetQueryParameters();
    var analyticsKeys = ['utm_source','utm_campaign','utm_term','utm_medium','utm_content'];
    var analyticsVars = w.Kinougarde.GetStorage('Kinougarde-analytics') | {};
    var enregistreranalyticsVar = false;
    try {
        jQuery.each(queryParams, function (key, value) {
        if (jQuery.inArray(key, analyticsKeys) > -1) {
            // Si un des utm est présent, on enregistre la variable
            if (enregistreranalyticsVar==false) {
                enregistreranalyticsVar=true;
                analyticsVars = {};
            }
            analyticsVars[key] = value;
        }        
        if( key=='gclid' && enregistreranalyticsVar) {
            //  Click id google            
            analyticsVars['clickid'] = value;            
            analyticsVars['clicksource'] = 'google';            
        }
        else if(key=='msclkid' && enregistreranalyticsVar) {
            //  Click id google
            analyticsVars['clickid'] = value;
            analyticsVars['clicksource'] = 'bing';            
        }
        else if (key== 'clickid' && enregistreranalyticsVar) {
            // Click id autre (ex: talent.com)            
            analyticsVars['clickid'] = value;
            analyticsVars['clicksource'] = Kinougarde.GetParameterByName("utm_source");            
        }
        });

        if (enregistreranalyticsVar) {        
            w.Kinougarde.SetStorage('Kinougarde-analytics',analyticsVars);            
        }    
       
    }
    catch (e) {
        console.warn("Erreur in GetGlobalQueryParameter");
    }
    };
 
    /**
     * Retourne un tableau paramètre :
     * ex Kinougarde.GetQueryParameters("utm_source=toto&utm_content=dddd");
     * -->  {utm_source: 'toto', utm_content: 'dddd'}
     * @param {clé du paramètre} str 
     */
    w.Kinougarde.GetQueryParameters = function (str) {
        var result = (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
            return n = n.split("="), this[n[0]] = n[1], this
        }.bind({}))[0];
        if ('object' == typeof result) {
            jQuery.each(result, function (key, value) {
                result[key] = encodeURI(value);
            });
        }    
        return result;    
    }

    /**
     * Retourne la valeur d'un parametre de l'url :
     * Ex :   Kinougarde.GetParameterByName('utm_source')
     * -->   retourne   "google"
     * @param {nom du paramètre} name
     */
     w.Kinougarde.GetParameterByName = function (name) {
        var url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
 
    /**
     * Retourne la valeur d'un cookie
     * @param {cookie name} cname 
     */
    w.Kinougarde.GetCookie = function(cname) {
       var name = cname + "=";
       var ca = document.cookie.split(';');
       for(var i = 0; i < ca.length; i++) {
         var c = ca[i];
         while (c.charAt(0) == ' ') {
           c = c.substring(1);
         }
         if (c.indexOf(name) == 0) {
           return c.substring(name.length, c.length);
         }
       }
       return "";
    }

      /**
     *  Affecte un cookie
     * @param {Cookie name} cname 
     * @param {Cookie value} cvalue 
     * @param {Expiration en jour} exdays 
     */
    w.Kinougarde.SetCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    /**
     * Retourne true ou false selon l'heure et les horaires d'ouverture passé à la function
     * @param {*} horaires
     * @returns
     */
    w.Kinougarde.isKinougardeOpen = function(horaires) {
            var now = new Date();
            //now = new Date(2022,7,26,19); //pipotage date pour test
            if (horaires !== undefined) {
                // Des horaires sont passés en paramètre
                var horaire = horaires[now.getDay()];
                if (horaires!=null) {
                    // Un horaire est définit
                    var startend = horaire.split('-');
                    var start = startend[0];
                    var end = startend[1];
                    var timeStart =  new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
                    timeStart.setMinutes(+start*60);
                    var timeEnd = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
                    timeEnd.setMinutes(+end*60);
                    return now>timeStart && now <timeEnd;
                }
            }
            if(now.getDay()==0 ) {
                //Dimanche = Fermé
                return false;
            } else if (now.getDay()==6) {
                // Samedi Fermé
                return false;
                //return now>new Date(now.getFullYear(),now.getMonth(),now.getDate(),9,0) && now<new Date(now.getFullYear(),now.getMonth(),now.getDate(),17,30);
            } else {
                // Les autre jour entre 9h00 et 18h00
                return now>new Date(now.getFullYear(),now.getMonth(),now.getDate(),9,0) && now<new Date(now.getFullYear(),now.getMonth(),now.getDate(),18,0);
            }
    }
    
    /**
     * Update agence mise à jour des champs utilisant des infos agences
     */
    w.Kinougarde.UpdateAgence = function(agence) {
        try {
            w.Kinougarde.agence = agence;
            Kinougarde.SetStorage('agency_id',agence.Id);
            Kinougarde.SetStorage('agence',agence);
            var now = new Date();
            //now =date.setTime(date.getTime() + 9 * 60 * 60 * 1000)  // pipotage de l'heure pour des tests +9h
            if (agence==null) { agence== Kinougarde.agence;}
            var horaires = [ null,agence.HoraireLundi,agence.HoraireMardi,agence.HoraireMercredi,agence.HoraireJeudi,agence.HoraireVendredi,agence.HoraireSamedi];
            var horaireAujourdhui = Kinougarde.getLibelleHoraire(horaires[now.getDay()]);
            var horaireDemain = Kinougarde.getLibelleHoraire(horaires[(now.getDay()+1)%7]);
            agence = Object.assign(agence,{"HoraireAujourdhui": Kinougarde.isKinougardeOpen(horaires) ? ("Ouvert aujourd'hui " + horaireAujourdhui) : "Ouvert demain " + horaireDemain});
            agence.HoraireLundi = Kinougarde.getLibelleHoraire(agence.HoraireLundi);
            agence.HoraireMardi = Kinougarde.getLibelleHoraire(agence.HoraireMardi);
            agence.HoraireMercredi = Kinougarde.getLibelleHoraire(agence.HoraireMercredi);
            agence.HoraireJeudi = Kinougarde.getLibelleHoraire(agence.HoraireJeudi);
            agence.HoraireVendredi = Kinougarde.getLibelleHoraire(agence.HoraireVendredi);
            agence.HoraireSamedi = Kinougarde.getLibelleHoraire(agence.HoraireSamedi);                                    
            jQuery('body').mapObject(agence,"agence");
        }
        catch (e) {
            console.info('Error in Kinougarde.UpdateAgence');
        }
    }    


    /**
     * Retourne une promise avec les infos de l'agence
     *  - retourne les infos stockées dans le session storage (ne pas les stocker dans le localstorage car pas de mise à jour en cas de changement) 
     *  - ou effectue une requete ajax pour obtenir les infos
     */
    w.Kinougarde.GetAgency = function(id) {      
        if (id===null && typeof(window.Kinougarde.agence)!=='undefined' || (typeof(window.Kinougarde.agence)!=='undefined' && window.Kinougarde.agence && id==window.Kinougarde.agence.Id)) {
          // Agence dans la variable globale
          return new Promise(function (resolve) {
            resolve(window.Kinougarde.agence);
          });        
        }      
        else if ((id===null && Kinougarde.GetStorage('agence')) || (Kinougarde.GetStorage('agence') && w.Kinougarde.GetStorage('agency_id')==id)) {
            // Agence stockée dans le session storage (une page avec un contexte agence a déjà été vue lors de la session)
            return new Promise(function (resolve) {
            resolve(Kinougarde.GetStorage('agence'));
          });        
        }
        else if (id===null && typeof(window.Kinougarde.agence)==='undefined' && !w.Kinougarde.GetStorage('agency_id')) {
          // Pas d'agence et pas d'id agence sauvegardé dans le local storage
          return new Promise(function (resolve) {
            resolve(null);
          });        
        }
        else {
          if (id===null && w.Kinougarde.GetStorage('agency_id')) {
            id = w.Kinougarde.GetStorage('agency_id');
          }
          // l'id est définit et non connu
          // Chargement ajax de l'agence
          return new Promise(
            function (resolve) {
                jQuery.ajax({
                url: '/ajax/agence/' + id +'/',
                type: 'get',                             
                success: function (reponse) {
                    if (reponse.success) {
                        window.Kinougarde.agence = reponse.data;
                        Kinougarde.SetStorage('agency_id',Kinougarde.agence.Id);
                        Kinougarde.SetStorage('agence',Kinougarde.agence);                        
                        resolve(Kinougarde.agence);
                    }
                }        
            }) // Fin promise
          });
  
        }
    }

    /**
     * Initialisation de l'agence selon les paramètres de la page
     */
    w.Kinougarde.InitAgence = function() {
        var idAgence = null;
        
        if (null !== document.querySelector('[data-setmyagency]')) {
            // Page agence
            idAgence = document.querySelector('[data-setmyagency]').getAttribute('data-setmyagency')
        } else if(Kinougarde.GetParameterByName('ag')!=null) {
            // Paramètre agence
            idAgence = Kinougarde.GetParameterByName('ag');                
        }         
        w.Kinougarde.GetAgency(idAgence).then(function(agence) {
            // Mise à jour de la variable globale  
            $(document).trigger( "agence-loaded" , [agence]);          
            Kinougarde.UpdateAgence(agence);
            Kinougarde.ShowBoutonSticky();
        });        
    }


    /**
     * Retourne la chaine corespondant à l'horaire
     * 9-17.5  ==>  9h-17h30
     * @param {int} horaire 
     */
    w.Kinougarde.getLibelleHoraire = function(horaire) {
        if (horaire==null) return "";
        var now = new Date();
        var startend = horaire.split('-');
        var start = startend[0];
        var end = startend[1];
        var timeStart =  new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
        timeStart.setMinutes(+start*60);
        var timeEnd = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
        timeEnd.setMinutes(+end*60);
        return timeStart.getHours() + "h" + (timeStart.getMinutes()!='0' ? timeStart.getMinutes():'') +"-" + timeEnd.getHours()+ "h" + (timeEnd.getMinutes()!='0' ? timeEnd.getMinutes():'');
    }    


    /**
     * Post des données en Ajax sur une page
     */
     w.Kinougarde.PostSurPage = function(url,postData) {      
        {
            var postFormStr = "<form method='POST' action='" + url + "'>\n";
            for (var key in postData)
            {
                if (postData.hasOwnProperty(key))
                {
                    postFormStr += "<input type='hidden' name='" + key + "' value='" + postData[key] + "'></input>";
                }
            }
            postFormStr += "</form>";
            var formElement = $(postFormStr);
    
            $('body').append(formElement);
            $(formElement).submit();
    
        }
    }


    /**
     * Initialisation d'une carte google map
    */
    w.Kinougarde.initMap = function (selector,zoom) {        
        const icon = {path: "m 29.7 90 c 1.35 0 2.61 -0.6 3.51 -1.6 c 0.27 -0.3 6.57 -7.5 12.87 -17.6 c 8.82 -14.1 13.32 -26.5 13.32 -37 c 0 -18.7 -13.32 -33.8 -29.7 -33.8 s -29.7 15.1 -29.7 33.8 c 0 10.5 4.5 23 13.32 37 c 6.39 10.1 12.6 17.3 12.87 17.6 c 0.9 1 2.16 1.6 3.51 1.6 z m -12.69 -59.5 c 0 -8 5.67 -14.5 12.69 -14.5 s 12.69 6.5 12.69 14.5 s -5.67 14.5 -12.69 14.5 s -12.69 -6.5 -12.69 -14.5 z",
            fillColor     : '#D1007F',
            fillOpacity   : 1,
            strokeWeight  : 0,
            strokeOpacity : 1,
            scale         : 0.35,            
            anchor        : new google.maps.Point(0,0)};                                    
        const iconHome = {
            url: pictoHome,  
            fillColor     : '#0000',
            fillOpacity   : 1,
            strokeWeight  : 0,
            strokeOpacity : 1,
            scaledSize    :  new google.maps.Size(30,40),            
            anchor        : new google.maps.Point(0,0)};                                    

        const iconInactif = {path: "m 29.7 90 c 1.35 0 2.61 -0.6 3.51 -1.6 c 0.27 -0.3 6.57 -7.5 12.87 -17.6 c 8.82 -14.1 13.32 -26.5 13.32 -37 c 0 -18.7 -13.32 -33.8 -29.7 -33.8 s -29.7 15.1 -29.7 33.8 c 0 10.5 4.5 23 13.32 37 c 6.39 10.1 12.6 17.3 12.87 17.6 c 0.9 1 2.16 1.6 3.51 1.6 z m -12.69 -59.5 c 0 -8 5.67 -14.5 12.69 -14.5 s 12.69 6.5 12.69 14.5 s -5.67 14.5 -12.69 14.5 s -12.69 -6.5 -12.69 -14.5 z",
            fillColor     : '#D3AFBE',
            fillOpacity   : 1,
            strokeWeight  : 0,
            strokeOpacity : 1,
            scale         : 0.30,            
            anchor        : new google.maps.Point(0,0)}; 

        const kinougardeMapStyle =
            [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road.highway", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "transit", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit.station", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.bus", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "stylers": [ { "color": "#aad2e3" }, { "visibility": "on" } ] } ];                        

        self.map = new google.maps.Map(document.getElementById(selector), {
            center: { lat: self.Latitude, lng: self.Longitude },
            zoom: parseInt(zoom),
            styles : kinougardeMapStyle,  
            streetViewControl : false,              

        });                    
    }



    /**
     * Envoi à analytique 'TunnelPageView'
     * ex :  Kinougarde.TagManagerTunnel()  --> Envoi d'un event 'TunnelPageView' avec 'TunnelStep' égal a l'attribut data-step-kpi  de l'étape active
     *       Kinougarde.TagManagerTunnel('nom_etape')  --> Envoi d'un event 'TunnelPageView' avec 'TunnelStep' égal a 'nom_etape'
     *       Kinougarde.TagManagerTunnel('nom_etape',{event : 'DisplayOfferListFull'}) --> Envoi d'un event 'DisplayOfferListFull' avec 'TunnelStep' égal a 'nom_etape'
     */
     w.Kinougarde.TagManagerTunnel = function(step=null, options=null) {
        try {
            if (typeof(dataLayer)!=="undefined") {
                if (step===null)  {
                    // Recherche de l'étape active
                    if ($(".owl-item.active .step-form[data-step-kpi]").length>0) {
                        step =  $(".owl-item.active .step-form[data-step-kpi]").data("step-kpi");
                    } else {
                        //Pas de tracking sur cette étape
                        return;
                    }
                }
                var data = Object.assign({
                    'event': 'TunnelPageView',
                    'TunnelStep': step                    
                },options);
                                          
                // Info déjà postulé
                if (Kinougarde.dejaPostule()===true) {
                    data = Object.assign(data,{ 'InfoUserTunnel': 'DejaPostule'})
                }
                // Info agence
                if (window.Kinougarde.agence!==null && typeof(window.Kinougarde.agence)!=='undefined') {
                     data = Object.assign(data, {'agence' : window.Kinougarde.agence.name});
                }
                console.debug('dataLayer.push  step: ' + JSON.stringify(data));                
                dataLayer.push(data);
                $(document).trigger( "data-step-kpi" , [step]);
            }
        }
        catch (e) {
            console.warn("erreur dans w.Kinougarde.TagManagerTunnel");
        }
    }

    /**
     * Retourne true si l'utilisateur a déjà postulé false sinon
     */
     w.Kinougarde.dejaPostule  = function() {
        var postuler =  w.Kinougarde.GetStorage("form-postuler");
        return typeof(postuler)!=='undefined' && postuler!==null;
    }

    /**
     * Track les clics sur les numéros de téléphone
     */
    w.Kinougarde.ClicNumeroTelephone = function() {
        $("a[href^='tel:']").on('click',function(e) {
            try {
            $.ajax({
                type: 'POST',
                url: ajax_kinougarde_object.ajaxurl,
                data:  {action : 'fb_contact' , url :  document.location.href }                                
            });
            } catch (e) {}
        });
    }

    /**
     *  Gestion de l'affichage du banner mobile selon les heures d'ouverture de l'agence (0=dimanche, 1=Lundi ... 6=samedi)
     */
    w.Kinougarde.ShowBoutonSticky = function() {
        try {
        var horaires = [ null,"9-19","9-19","9-19","9-19","9-19",null];
        
        if (($('div.sticky-banner').data('hide-banner')===undefined || Kinougarde.isKinougardeOpen(horaires)) && sessionStorage.getItem("sticky-banner-closed")==null) {
              //Affiche le banner
              $('div.sticky-banner').removeClass('hidden');
        } else {                            
              // Le banner est masqué par défaut
         };
        }
        catch (e) {
            console.debug('Erreur in ShowBoutonSticky()');
        }

    }
    
    
    jQuery(function() {      
        // Charge les paramètres globaux
        w.Kinougarde.GetGlobalQueryParameter();       
        w.Kinougarde.InitAgence();        
        w.Kinougarde.ClicNumeroTelephone();
    })

})(window);
